module.exports = __webpack_public_path__ + "img/pattern.94fbcaa1.jpg";